<template>
  <div class="d-flex position-relative page-folder-tree">
    <treeselect
      v-model="folder"
      :options="folders"
      :searchable="false"
      :show-count="true"
      no-options-text="No folders created"
      placeholder="All Pages"
      readonly
    >
      <label
        slot="value-label"
        slot-scope="{ node}"
      >
        {{ node.raw.name }}
      </label>

      <label
        slot="option-label"
        slot-scope="{ node, labelClassName }"
        :class="labelClassName"
      >
        {{ node.raw.name }}
      </label>
    </treeselect>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import {mapState} from 'vuex'

export default {
  name: 'PageFoldersTreeSelect',
  components: {Treeselect},
  props: {
    value: {
      required: true
    },
    ignoreId: {
      type: Number,
      default: 0
    },
    showChevronIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      folders: []
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    folder: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  created () {
    axios.get(`api/projects/${this.project.id}/pages/categories/tree?ignoreId=${this.ignoreId}`)
      .then(({data}) => {
        this.folders = [{id: 0, name: 'All Pages'}, ...data.data]
      })
  }
}
</script>
